// @ts-check
import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import Button from '@liquidweb-dev/undercurrent/Button';
import DrawerReboot from 'components/standard/DrawerReboot';
import ActionsContainer from './ActionsContainer';
import ActionsMenu from './ActionsMenu';

/** @param {import('modules/queries/asset/useDetails').AssetDetails} props */
const ActionsContent = (props) => {
	const { powerStatus, status, uniq_id: uniqId, isPrivateParent } = props;

	const [isRebootDrawerOpen, setIsRebootDrawerOpen] = useState(false);

	const isActive = status === 'Active';
	const showReboot = !isPrivateParent && powerStatus !== 'unknown';
	const rebootDisabled = !isActive || powerStatus !== 'on';

	const location = useLocation();
	const history = useHistory();

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		if (!params.has('reboot')) return;
		if (showReboot && !rebootDisabled) {
			setIsRebootDrawerOpen(true);
		}
		params.delete('reboot');
		history.replace({ search: params.toString() });
	}, [location.search, showReboot, rebootDisabled, history]);

	return (
		<ActionsContainer>
			{showReboot && (
				<Button
					variant="primary"
					size="large"
					disabled={rebootDisabled}
					onClick={() => setIsRebootDrawerOpen(true)}
					sx={{ width: { xs: '100%', md: 'auto' } }}
				>
					Reboot
				</Button>
			)}

			<ActionsMenu {...props} intent="serverInterior" />

			<DrawerReboot
				open={isRebootDrawerOpen}
				onClose={() => setIsRebootDrawerOpen(false)}
				uniqId={uniqId}
			/>
		</ActionsContainer>
	);
};

export default ActionsContent;
